import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { createUri, Api } from '@api/utils';
import { CutStateUrl } from '@api/cutstate';
import { Query } from './utils';

export const cutStateHooks = createApi({
    reducerPath: 'cutStateApi',
    baseQuery: fetchBaseQuery({
        baseUrl: createUri(Api.CutState, '/cutstate/V1'),
    }),
    endpoints: (build) => ({
        invoiceDates: build.query<[string, string[]][], { token: string }>({
            query: ({ token }) => ({
                url: CutStateUrl.InvoiceDates,
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }),
        }),
        invoiceJobs: build.query<
            { downloadUrl: string; fileName: string; lastModified: string; size: string }[],
            { token: string; year: string; month: string }
        >({
            query: ({ token, ...params }) => ({
                url: CutStateUrl.InvoiceJobs,
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                params,
            }),
        }),
    }),
});

/** Intermediary Wrapper */
const cutState = {
    useInvoiceDatesQuery: Query.withToken(cutStateHooks.useInvoiceDatesQuery),
    useInvoiceJobsQuery: Query.withToken(cutStateHooks.useInvoiceJobsQuery),
};

export const { useInvoiceDatesQuery, useInvoiceJobsQuery } = cutState;
